import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {ReactComponent as EmptySearchResultSvgImage} from '../../static/images/pages/empty-search-result.svg';
import Empty from '../Empty';
import Spin from '../Spin';

const NoSearchResults = ({
  image,
  spinning,
  title,
  value,
  ...rest
}) => {
  const [trans] = useTranslation('main');
  const t = (key) => trans(`noSearchResults.${key}`);

  return (
    <Spin spinning={spinning}>
      <Empty
        description={value ? (
          <>
            {t('description1')} <b>{value}</b>.
            <br/>
            {t('description2')}
          </>
        ) : undefined}
        image={image || <EmptySearchResultSvgImage />}
        title={title || t('title')}
        {...rest}
      />
    </Spin>
  );
}

NoSearchResults.propTypes = {
  image: PropTypes.any,
  spinning: PropTypes.bool,
  title: PropTypes.any,
  value: PropTypes.string
}

export default NoSearchResults;
